import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import { config } from "vuex-module-decorators";
import SecureLS from "secure-ls";

import AuthModule from "@/store/modules/AuthModule";
import BodyModule from "@/store/modules/BodyModule";
import ConfigModule from "@/store/modules/ConfigModule";
import ThemeModeModule from "@/store/modules/ThemeModeModule";

import socket from "@/core/services/SocketService";

config.rawError = true;

var ls = new SecureLS({ isCompression: false });

const getters = {
  socket: () => socket,
};

const store = createStore({
  getters,
  plugins: [
    createPersistedState({
        storage: {
            getItem: key => ls.get(key),
            setItem: (key, value) => ls.set(key, value),
            removeItem: key => ls.remove(key)
        }
    })
  ],
  modules: {
    AuthModule,
    BodyModule,
    ConfigModule,
    ThemeModeModule,
  },
});

export default store;
